<template>
  <div class="player-container">
    
    <!-- PAID STATE: Video Player (Image 3) -->
    <div v-if="isPaid" class="paid-view">
      <!-- Player Area -->
      <div class="video-wrapper">
         <video 
            ref="videoPlayer" 
            class="video-js vjs-big-play-centered" 
            controls 
            preload="auto" 
            width="100%" 
            height="100%"
            data-setup="{}"
         >
            <source :src="videoUrl" type="application/x-mpegURL">
         </video>
      </div>
      
      <!-- Video Info -->
      <div class="video-info-bar">
        {{ title }}
      </div>

      <!-- Action Buttons (Image 3) -->
      <div class="action-buttons">
         <button class="act-btn btn-yellow" @click="$router.push('/')">返回首页</button>
         <button class="act-btn btn-yellow" @click="pageRefresh">刷新</button>
         <button class="act-btn btn-yellow" @click="requestRefund">申请退赔</button>
      </div>

      <!-- Red Warning Banner (Image 3) -->
      <div class="warning-banner">
        本站不提供任何约炮服务，勿信视频内广告，本站只是看片，请勿受骗!
      </div>

      <!-- Recommendations -->
      <div class="rec-section">
         <div class="rec-header">
            <div class="rec-title"><van-icon name="star-o" /> 为你推荐</div>
            <button class="change-batch" @click="fetchRecommendations">换一批</button>
         </div>
         <div class="rec-grid">
             <div class="rec-item" v-for="(item, idx) in recommendations" :key="idx" @click="switchVideo(item)">
                <div class="rec-img">
                   <img :src="item.coverUrl || 'https://dummyimage.com/300x200/333/fff.png&text=Rec'" />
                   <div class="rec-duration">12:30</div>
                </div>
                <div class="rec-text clamp-2">{{ item.title }}</div>
             </div>
         </div>
      </div>
    </div>


    <!-- UNPAID STATE: Paywall (Image 2) -->
    <div v-else class="unpaid-view">
       <!-- Mock Background or blurry preview -->
       <div class="paywall-bg">
          <img :src="'https://dummyimage.com/300x200?text=Bg'" class="bg-blur" />
       </div>

       <!-- Overlay Content -->
       <div class="paywall-overlay">
          <!-- Header -->
          <div class="pw-header">
             <span>视频在已购页面观看</span>
             <van-icon name="cross" class="close-icon" @click="$router.back()" />
          </div>

          <!-- Title & Prompt -->
          <div class="pw-info">
             <div class="pw-title">{{ title }}</div>
             <div class="pw-subtitle">想要找出情色污垢的巨乳新人OL意外地疯狂...</div>
          </div>
         
          <!-- Cover Preview -->
          <div class="pw-cover">
             <img :src="coverUrl || 'https://dummyimage.com/300x200/000/fff.png&text=Preview'" />
          </div>

          <!-- Price List -->
           <div class="price-list">
              <button 
                 v-for="item in pricingList" 
                 :key="item.type" 
                 :class="['price-btn', item.isMembership ? 'btn-orange' : 'btn-light']" 
                 @click="buy(item)"
              >
                 {{ item.name }}¥{{ item.price }}
              </button>
           </div>
       </div>
    </div>

    <div class="bottom-nav">
      <div class="nav-item" @click="$router.push('/')"><div class="nav-btn btn-dark">首页</div></div>
      <div class="nav-item" @click="$router.push('/purchased')"><div class="nav-btn btn-yellow">已购</div></div>
      <div class="nav-item" @click="$router.push('/user')"><div class="nav-btn btn-yellow">账号</div></div>
      <div class="nav-item" @click="showBookmarkModal = true"><div class="nav-btn btn-dark">收藏本站</div></div>
    </div>

    <!-- Bookmark Modal -->
    <div class="modal-mask" v-if="showBookmarkModal">
       <div class="modal-box">
          <div class="modal-header">
             <span>收藏本站 永不迷路</span>
             <div class="close-btn" @click="showBookmarkModal = false">
               <van-icon name="cross" size="20" color="#fff" />
             </div>
          </div>
          <div class="modal-body">
             <div class="green-text">
                重要提示!!!请截图保存本站最新网址! ! ! 已付款的请在已购处播放!
             </div>
             <div class="orange-label">永久网址:</div>
             <div class="url-row">
                <span class="url-text">http://36x3.vip</span>
                <button class="copy-btn" @click="copyUrl">复制</button>
             </div>
             <div class="qr-label">截图保存本站二维码:</div>
             <div class="qr-box">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=http://36x3.vip" alt="QR" />
             </div>
          </div>
       </div>
    </div>

  </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  name: 'Player',
  data() {
    return {
      id: this.$route.query.id || this.$route.params.id,
      videoUrl: this.$route.query.url || this.$route.params.url,
      title: this.$route.query.title || this.$route.params.title,
      coverUrl: '',  // 视频封面
      isPaid: false,
      player: null,
      recommendations: [],
      pricingList: [],
      showBookmarkModal: false
    }
  },
  computed: {
    proxiedVideoUrl() {
      if (!this.videoUrl) return '';
      return '/proxy?url=' + encodeURIComponent(this.videoUrl);
    }
  },
  async mounted() {
      await this.ensureUserRegistered();  // 确保用户已注册
      this.checkAuth();
      this.fetchVideoDetails();  // 获取视频封面
      this.fetchRecommendations();
      this.fetchPricing();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    // 确保用户已注册（匿名用户自动注册）
    async ensureUserRegistered() {
        const userStr = localStorage.getItem('user');
        if (userStr) return; // 已登录，无需处理
        
        // 获取或生成 deviceId
        let deviceId = localStorage.getItem('deviceId');
        if (!deviceId) {
            deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('deviceId', deviceId);
        }
        
        try {
            const { data } = await this.$http.post('/auto-register', { deviceId });
            if (data.success && data.user) {
                localStorage.setItem('user', JSON.stringify(data.user));
                console.log('Auto-registered user:', data.user.username);
            }
        } catch (e) {
            console.warn('Auto-register failed:', e.message);
        }
    },
    async checkAuth() {
        const userStr = localStorage.getItem('user');
        const deviceId = localStorage.getItem('deviceId');
        
        // 1. 检查会员有效期
        if (userStr) {
            const user = JSON.parse(userStr);
            if (user.memberDate && new Date(user.memberDate) > new Date()) {
                this.isPaid = true;
                this.$nextTick(() => this.initPlayer());
                return;
            }
        }
        
        // 2. 检查是否购买了此单片
        if (this.id && (userStr || deviceId)) {
            try {
                const params = {};
                if (userStr) {
                    params.username = JSON.parse(userStr).username;
                }
                if (deviceId) {
                    params.deviceId = deviceId;
                }
                params.videoId = this.id;
                
                const { data } = await this.$http.get('/user/check-video-access', { params });
                if (data.hasAccess) {
                    this.isPaid = true;
                    // 优先使用后端返回的URL，如果没有则使用路由传入的URL
                    if (data.videoUrl) {
                        this.videoUrl = data.videoUrl;
                    }
                    // 如果仍然没有videoUrl，尝试从视频详情获取
                    if (!this.videoUrl && this.id) {
                        try {
                            const videoRes = await this.$http.get(`/videos/${this.id}`);
                            if (videoRes.data && videoRes.data.videoUrl) {
                                this.videoUrl = videoRes.data.videoUrl;
                            }
                        } catch (e) {
                            console.log('获取视频URL失败:', e);
                        }
                    }
                    console.log('播放视频URL:', this.videoUrl);  // Debug
                    this.$nextTick(() => this.initPlayer());
                    return;
                }
            } catch (e) {
                console.log('检查视频权限失败:', e);
            }
        }
        
        this.isPaid = false;
    },
    async fetchVideoDetails() {
        // 如果没有视频ID，无法获取详情
        if (!this.id) return;
        
        try {
            const { data } = await this.$http.get(`/videos/${this.id}`);
            if (data && data.coverUrl) {
                let cover = data.coverUrl;

                this.coverUrl = cover;
            }
        } catch (e) {
            console.log('获取视频详情失败:', e);
        }
    },
    initPlayer() {
        setTimeout(() => {
            if (!this.$refs.videoPlayer) return;
            this.player = videojs(this.$refs.videoPlayer, {
                fluid: true,
                autoplay: 'muted',  // 静音自动播放（浏览器允许）
                muted: true,
                controls: true,
                html5: { vhs: { overrideNative: true } }
            });
            if (this.videoUrl) {
                // Use proxy to avoid CORS
                const src = '/api/proxy?url=' + encodeURIComponent(this.videoUrl);
                this.player.src({ src, type: 'application/x-mpegURL' });
                // 尝试播放，失败则等待用户点击
                this.player.play().then(() => {
                    // 播放成功后取消静音
                    this.player.muted(false);
                }).catch(e => {
                    console.log('等待用户点击播放:', e.message);
                });
            }
        }, 200);
    },
    buy(item) {
      // Navigate to Cashier page for payment method selection
      this.$router.push({
        path: '/cashier',
        query: {
          amount: item.price,
          type: item.type,
          title: item.name || '视频购买',
          videoId: this.id,
          videoTitle: this.title || 'Unknown Video'
        }
      });
    },
    async buyDirect(item) {
        const userStr = localStorage.getItem('user');
        let requestBody = { 
            type: item.type,
            amount: item.price,
            videoId: this.id,
            videoTitle: this.title || 'Unknown Video'
        };

        if (userStr) {
            const user = JSON.parse(userStr);
            requestBody.username = user.username;
        } else {
            let deviceId = localStorage.getItem('deviceId');
            if (!deviceId) {
                deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                localStorage.setItem('deviceId', deviceId);
            }
            requestBody.deviceId = deviceId;
        }

        const promoterId = localStorage.getItem('promoterId');
        if (promoterId) requestBody.promoterId = promoterId;

        try {
            this.$toast.loading({ duration: 0, forbidClick: true, message: '请求中...' });
            const { data } = await this.$http.post('/fiuu/direct-pay', requestBody);
            this.$toast.clear();
            
            if (data.success && data.directData) {
                if (data.user) {
                    localStorage.setItem('user', JSON.stringify(data.user));
                }
                
                // Handle Direct Response
                const dd = data.directData;
                console.log('Direct Data:', dd);

                // Priority 1: AppDeeplink (URL)
                if (dd.AppDeeplink && dd.AppDeeplink !== 'False' && dd.AppDeeplink !== 'True') {
                     window.location.href = dd.AppDeeplink;
                     return;
                }
                
                // Priority 2: QR Code (if in output string or specific field)
                // Fiuu output often in 'url' or implicit. 
                // However, our backend just returns the JSON. 
                // If text/html is returned, we might need to render it.

                // If 'url' exists (common for some gateways)
                if (dd.url) {
                    window.location.href = dd.url;
                } else {
                    // Fallback: Show Modal with Raw Data (for testing as we rely on user credentials)
                    this.$dialog.alert({
                        title: '支付宝直连',
                        message: '支付链接获取成功 (请检查弹窗/控制台): ' + JSON.stringify(dd)
                    });
                }

            } else {
                this.$toast.fail('创建订单失败');
            }
        } catch (e) {
            this.$toast.clear();
            this.$toast.fail('支付请求失败: ' + (e.response?.data?.error || e.message));
        }
    },
    async fetchRecommendations() {
        try {
           const { data } = await this.$http.get('/videos', { 
               params: { random: true } 
           });
           // Take 4 random videos and fix cover URLs
           this.recommendations = data.slice(0, 4).map(v => {
               let cover = v.coverUrl || 'https://dummyimage.com/300x200/333/fff.png&text=Rec';

               return {
                   ...v,
                   coverUrl: cover
               };
           });
        } catch(e) {
            console.log(e);
        }
    },
    async fetchPricing() {
        try {
           const { data } = await this.$http.get('/pricing');
           this.pricingList = data;
        } catch(e) {
            console.log('Failed to fetch pricing:', e);
        }
    },
    pageRefresh() {
        // 不使用 location.reload()，因为视频参数会丢失
        // 重新初始化播放器
        if (this.player) {
            this.player.dispose();
            this.player = null;
        }
        this.$nextTick(() => {
            this.checkAuth();
            this.$toast.success('刷新成功');
        });
    },
    requestRefund() {
        this.$toast('申请已提交');
    },
    switchVideo(item) {
        // Simple reload with new params
        this.videoUrl = item.videoUrl;
        this.title = item.title;
        this.id = item.id;  // 更新视频ID
        // If player exists, src update with proxied URL
        if (this.player) {
            const proxiedUrl = '/api/proxy?url=' + encodeURIComponent(item.videoUrl);
            this.player.src({ src: proxiedUrl, type: 'application/x-mpegURL' });
            this.player.play();
        }
        window.scrollTo(0,0);
    },
    bookmarkSite() {
        this.showBookmarkModal = true;
    },
    copyUrl() {
        const input = document.createElement('input');
        input.setAttribute('value', 'http://36x3.vip');
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$toast.success('复制成功');
    }
  }
}
</script>

<style scoped>
.player-container {
    background: #000;
    min-height: 100vh;
    color: #fff;
    padding-bottom: 60px;
}

/* UNPAID STYLES */
.unpaid-view {
    position: relative;
    padding: 10px;
}
.paywall-bg {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 0;
    opacity: 0.3;
    pointer-events: none;
}
.paywall-overlay {
    position: relative;
    z-index: 10;
    background: rgba(20,20,20, 0.95);
    border: 1px solid #333;
    border-radius: 5px;
    overflow: hidden;
}
.pw-header {
    background: #333;
    color: #ffaa00;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
}
.pw-info {
    padding: 10px;
}
.pw-title {
    font-weight: bold;
    margin-bottom: 5px;
}
.pw-subtitle {
    font-size: 12px;
    color: #aaa;
}
.pw-cover img {
    width: 100%;
    display: block;
}
.price-list {
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.price-item-row {
    display: flex;
    gap: 10px;
}
.price-btn {
    flex: 2; /* Main button takes more space */
    padding: 12px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.price-btn-small {
    flex: 1; /* Direct button smaller */
    padding: 12px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
}
.btn-light {
    background: linear-gradient(to right, #ffffcc, #fff);
    color: #000;
}
.btn-orange {
    background-color: #ff8800; /* Darker orange */
    color: #000;
}
.btn-blue {
    background-color: #007bff;
    color: white;
}

/* PAID STYLES */
.video-wrapper {
    width: 100%;
    background: #000;
}
.video-info-bar {
    padding: 10px;
    color: #fff;
    font-size: 14px;
    background: #111;
}
.action-buttons {
    display: flex;
    gap: 10px;
    padding: 10px;
    justify-content: space-around;
}
.act-btn {
    flex: 1;
    padding: 8px 0;
    text-align: center;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
}
.btn-yellow {
    background-color: #ffaa00;
    color: #000;
}
.warning-banner {
    background-color: #ff0000;
    color: white;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}
.rec-section {
    padding: 10px;
}
.rec-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.rec-title {
    color: #ffaa00;
    font-size: 16px;
}
.change-batch {
    background: transparent;
    border: 1px solid #ffaa00;
    color: #ffaa00;
    padding: 2px 10px;
    border-radius: 15px;
    font-size: 12px;
}
.rec-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.rec-item {
    width: 48%;
    margin-bottom: 10px;
}
.rec-img {
    width: 100%;
    height: 100px;
    background: #333;
    position: relative;
}
.rec-img img { width: 100%; height: 100%; object-fit: cover; }
.rec-duration {
    position: absolute;
    right: 5px; bottom: 5px;
    background: rgba(0,0,0,0.7);
    color: #fff;
    font-size: 10px;
    padding: 2px;
}
.rec-text {
    font-size: 12px;
    color: #ddd;
    margin-top: 5px;
}

/* Bottom Nav - Shared */
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #111;
    display: flex;
    padding: 5px 0;
    border-top: 1px solid #333;
    z-index: 100;
}
.nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nav-btn {
    width: 80%;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    border-radius: 4px;
    font-weight: bold;
}
.btn-dark {
    background-color: #222;
    color: white;
    border: 1px solid #444;
}

/* Bookmark Modal Styles */
.modal-mask {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.modal-box {
    background: #1a1a2e;
    border-radius: 8px;
    width: 90%;
    max-width: 400px;
    overflow: hidden;
}
.modal-header {
    background: #222;
    color: #ffa500;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
}
.close-btn { cursor: pointer; }
.modal-body {
    padding: 15px;
    text-align: center;
}
.green-text {
    color: #00ff00;
    font-size: 14px;
    margin-bottom: 10px;
}
.orange-label {
    color: #ffa500;
    margin: 10px 0 5px;
}
.url-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}
.url-text {
    color: #4fc3f7;
    font-size: 20px;
    font-weight: bold;
}
.copy-btn {
    background: #ffa500;
    color: #000;
    border: none;
    padding: 5px 15px;
    border-radius: 15px;
    cursor: pointer;
}
.qr-label {
    color: #ffa500;
    margin: 10px 0;
}
.qr-box img {
    background: white;
    padding: 10px;
    border-radius: 5px;
}
</style>
